import React, { useState } from "react";

import FormStrip from "../../components/FormStrip";
import SubStep2 from "./Step1/SubStep2";
import { MainWrapper, PrimaryTab, PrimaryTabs, PrimaryTabsWrapper, SubTab, SubTabs, SubTabsWrapper } from "../../components/StyledComponent";
import { useTranslation } from "react-i18next";

import ReactToPrint from "react-to-print";
import ButtonWrapper from "../../components/Button";
import { Card } from "@mui/material";
import NOCTakeAction from "@egovernments/digit-ui-module-common/src/sharedComponents/NOCTakeAction";
import SubStep1 from "./Step1/SubStep1";
import { BackButton, Toast } from "@egovernments/digit-ui-react-components";
import useCompletionPortalLogic from "./hooks/useCompletionPortalLogic";
import SubStep3 from "./Step1/SubStep3";
import SubStep4 from "./Step1/SubStep4";
import Step2 from "./Step2";
import Step5 from "./Step5";
import SearchSummary from "../map-submission/Summary/SearchSummary";
import Step6 from "./Step6";
import IdentifyNoc from "../../reusableComponents/IdentifyNoc";
import CompletionChecklist from "./CompletionChecklist";
import Step7 from "./Step7";
const CompletionPortal = () => {
  const { t } = useTranslation();
  const logic = useCompletionPortalLogic(t);

  const {
    activeTab,
    setActiveTab,
    selectedSubTab,
    setSelectedSubTab,
    summaryShow,
    setSummaryshow,
    showToast,
    setShowToast,
    declarationChecked,
    handleDeclarationChange,
    closeToast,
    params,
    setParams,
    clearParams,
    tenantId,
    isEmployee,
    id,
    applicationData,
    isAppDataLoading,
    isSelfCert,
    componentRef,
    subTabLabels,
    handleTabChange,
    handleSubTabChange,
    onSelect,
    isCompounding,
    initFormMTDocs,
    isFeesRequired,
    isLayoutCase,
    isCitizen,
  } = logic;

  console.log("applicationData", params?.applicationNo, "allParamData", params ,"UD-projectset",id);

  const renderContent = () => {
    if (activeTab === 0) {
      switch (selectedSubTab) {
        case 0:
          return (
            <SubStep1
              formData={params}
              handleSubTabChange={handleSubTabChange}
              setFormData={setParams}
              initFormMTDocs={initFormMTDocs}
              setShowToast={setShowToast}
              isEmployee={isEmployee}
            />
          );
        case 1:
          return <SubStep3 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 2:
          return <SubStep2 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 3:
          return <SubStep4 formData={params} handleSubTabChange={handleSubTabChange} isEmployee={isEmployee} />;
        case 4:
          return (
            <React.Fragment>
              {params?.nocList?.length > 0 ? (
                <NOCTakeAction formData={params} />
              ) : (
                <IdentifyNoc
                  formData={params}
                  tenantId={tenantId}
                  handleTabChange={handleTabChange}
                  handleSubTabChange={handleSubTabChange}
                  isEmployee={isEmployee}
                />
              )}
            </React.Fragment>
          );

        // return <LandUseNOC formData={params} role={"CITIZEN"} handleTabChange={handleTabChange} Modal={Modal} />;
        // <SubStep5 formData={params} role="APPROVED_CITIZEN" handleTabChange={handleTabChange} handleSubTabChange={handleSubTabChange} isEmployees={isEmployee}/>;
        default:
          return null;
      }
    } else if (activeTab === 1) {
      return <Step2 formData={params} handleTabChange={handleTabChange} tenantId={tenantId} isEmployee={isEmployee} />;
    } else if (activeTab === 2 && !isCompounding) {
      // return <Step4 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
      return <Step5 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
    } else if (activeTab === 3 && !isCompounding) {
      // return <Step4 formData={params} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
      return <Step7 formData={params} id={params?.applicationNo} handleTabChange={handleTabChange} isEmployee={isEmployee} />;
    } else if (activeTab === 4) {
      return (
        <CompletionChecklist formData={params} isEmployee={isEmployee} handleTabChange={handleTabChange} isLayoutCase={isLayoutCase} isCitizen={isCitizen} />
      );
    } else if (activeTab === 5) {
      return (
        <div>
          <Card style={{ width: "90%", margin: "0 auto" }} ref={componentRef}>
            <SearchSummary
              id={params?.applicationNo}
              ref={componentRef}
              handleDeclarationChange={handleDeclarationChange}
              declarationChecked={declarationChecked}
              showDeclaration={true}
              formType="FORM_COMPLETION"
            />

            <div
              style={{
                margin: "20px",
                padding: "12px 16px",
                backgroundColor: "#fff3cd",
                border: "1px solid #ffeeba",
                borderRadius: "4px",
                color: "#856404",
                fontWeight: "500",
              }}
            >
              {t("FASTPAS.GLOBAL.ONCE.TEXT")}
            </div>
          </Card>
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ReactToPrint
                trigger={() => (
                  <ButtonWrapper variant="contained" color="success" size="medium" label="Print" sx={{ backgroundColor: "#7600bc" }}>
                    Print Summary
                  </ButtonWrapper>
                )}
                content={() => componentRef.current}
              />
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Preview"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleTabChange(0)}
              />
              <ButtonWrapper
                variant="contained"
                color="success"
                size="medium"
                label={isFeesRequired ? "MAKE PAYMENT" : "SUBMIT"}
                type="submit"
                sx={{ backgroundColor: "#157CB3", width: "180px" }}
                onClick={() => handleTabChange(5, params)}
                disabled={!declarationChecked}
              />
            </div>
          </div>
        </div>
      );
    } else if (activeTab === 6 && summaryShow && params?.applicationNo) {
      return <Step6 formData={params} handleSubTabChange={handleTabChange} />;
    }
  };

  return (
    <MainWrapper>
      <BackButton />
      <FormStrip formName={t("Completion Module")} />
      <PrimaryTabsWrapper>
        <PrimaryTabs value={activeTab} onChange={(e, i) => handleTabChange(i)} aria-label="Tab Group" variant="scrollable" scrollButtons="auto">
          <PrimaryTab label="Application Form" />
          <PrimaryTab label="Document" />
          <PrimaryTab label="Fees" />
          <PrimaryTab label="Drawing Details" />
          <PrimaryTab label="Checklist" />
          <PrimaryTab label="Summary" />
          <PrimaryTab label="Application History" />
        </PrimaryTabs>
      </PrimaryTabsWrapper>
      {activeTab === 0 && (
        <SubTabsWrapper>
          <SubTabs
            value={selectedSubTab}
            onChange={(e, i) => handleSubTabChange(i)}
            aria-label="Sub Tab Group"
            variant="scrollable"
            scrollButtons="auto"
          >
            {subTabLabels.map((tab, index) => (
              <SubTab key={index} label={tab.label} />
            ))}
          </SubTabs>
        </SubTabsWrapper>
      )}
      {renderContent()}
      {showToast && (
        <Toast error={showToast?.error} warning={showToast?.warning} label={t(showToast?.message)} onClose={closeToast} isDleteBtn={true} />
      )}
    </MainWrapper>
  );
};

export default CompletionPortal;
